import { put, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import { Types, Creators as ProductCreators } from '../../reducers/product';
import getState from '../../utils/getState';

function* setProductBuyTogether({ data }) {
  try {
    const { type, productId } = data;
    const { product } = yield select(getState);
    const selectedItems = product.getIn(['buyTogether', type, 'selectedItems']) || [];
    const exists = selectedItems.find((item) => item === productId);

    let newsSelectedItems = [];

    if (exists) {
      newsSelectedItems = selectedItems.filter((item) => item !== productId);
    } else {
      newsSelectedItems = [...selectedItems, productId];
    }

    yield put(
      ProductCreators.setProductBuyTogetherSuccess({
        type,
        selectedItems: newsSelectedItems,
      })
    );
  } catch (error) {
    yield put(ProductCreators.setProductBuyTogetherError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SET_PRODUCT_BUY_TOGETHER_REQUEST, setProductBuyTogether);
}
